"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class AppVersion {
  static thaw(appVersionObj) {
    if (appVersionObj == null) return null;
    const appVersion = new AppVersion();
    if (appVersionObj.id != null) appVersion.setId(appVersionObj.id);
    if (appVersionObj.semanticVersion != null) appVersion.setSemanticVersion(appVersionObj.semanticVersion);
    if (appVersionObj.ergoAlgoSegmentId != null) appVersion.setErgoAlgoSegmentId(appVersionObj.ergoAlgoSegmentId);
    if (appVersionObj.ergoAlgoSegment != null) appVersion.setErgoAlgoSegment(_.ErgoAlgoSegment.thaw(appVersionObj.ergoAlgoSegment));
    if (appVersionObj.evaluationVersions != null) appVersion.setEvaluationVersions(_.EvaluationVersion.thawList(appVersionObj.evaluationVersions));
    return appVersion;
  }

  static thawList(appVersionObjList) {
    if (appVersionObjList == null) return [];
    var appVersions = [];

    for (var i = 0; i < appVersionObjList.length; i++) {
      appVersions.push(AppVersion.thaw(appVersionObjList[i]));
    }

    return appVersions;
  }

  static freeze(appVersion) {
    if (appVersion == null) return null;
    var appVersionObj = {};
    if (appVersion.getId() != null) appVersionObj.id = appVersion.getId();
    if (appVersion.getSemanticVersion() != null) appVersionObj.semanticVersion = appVersion.getSemanticVersion();
    if (appVersion.getErgoAlgoSegmentId() != null) appVersionObj.ergoAlgoSegmentId = appVersion.getErgoAlgoSegmentId();
    if (appVersion.getErgoAlgoSegment() != null) appVersionObj.ergoAlgoSegment = _.ErgoAlgoSegment.freeze(appVersion.getErgoAlgoSegment());
    if (appVersion.getEvaluationVersions() != null) appVersionObj.evaluationVersions = _.EvaluationVersion.freezeList(appVersion.getEvaluationVersions());
    return appVersionObj;
  }

  static freezeList(appVersions) {
    if (appVersions == null) return [];
    var appVersionObjList = [];

    for (var i = 0; i < appVersions.length; i++) {
      appVersionObjList.push(AppVersion.freeze(appVersions[i]));
    }

    return appVersionObjList;
  }

  constructor() {
    this.setId(null);
    this.setSemanticVersion(null);
    this.setErgoAlgoSegmentId(null);
    this.setErgoAlgoSegment(null);
    this.setEvaluationVersions(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setSemanticVersion(semanticVersion) {
    this.semanticVersion = semanticVersion;
  }

  setErgoAlgoSegmentId(ergoAlgoSegmentId) {
    this.ergoAlgoSegmentId = ergoAlgoSegmentId;
  }

  setErgoAlgoSegment(ergoAlgoSegment) {
    this.ergoAlgoSegment = ergoAlgoSegment;
  }

  setEvaluationVersions(evaluationVersions) {
    this.evaluationVersions = evaluationVersions;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getSemanticVersion() {
    return this.semanticVersion;
  }

  getErgoAlgoSegmentId() {
    return this.ergoAlgoSegmentId;
  }

  getErgoAlgoSegment() {
    return this.ergoAlgoSegment;
  }

  getEvaluationVersions() {
    return this.evaluationVersions;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = AppVersion;